import { ChangeDetectionStrategy, Component, input, linkedSignal, output } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { Group } from 'app/providers/semantria-api/group.service';
import { Project } from 'app/providers/storage-api/project.service';

/**
 * Mobile navigation menu for the Spotlight Assistant drawer.
 */
@Component({
  selector: 'app-spotlight-assistant-mobile-menu',
  templateUrl: './spotlight-assistant-mobile-menu.component.html',
  imports: [AppSharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpotlightAssistantMobileMenuComponent {
  readonly isOpen = input.required<boolean>();
  readonly groups = input.required<Group[]>();
  readonly selectedGroup = input<Group | null>(null);
  readonly projects = input.required<Project[]>();
  readonly selectedProject = input<Project | null>(null);
  readonly projectsLoading = input<boolean>(false);

  readonly groupSelected = output<Group>();
  readonly projectSelected = output<Project>();
  readonly logoutRequested = output<void>();

  protected readonly groupExpanded = linkedSignal<boolean, boolean>({
    source: this.isOpen,
    computation: (isMenuOpen: boolean, previous?: { value: boolean }): boolean =>
      this.resolveExpansion(isMenuOpen, previous),
  });

  protected readonly projectExpanded = linkedSignal<boolean, boolean>({
    source: this.isOpen,
    computation: (isMenuOpen: boolean, previous?: { value: boolean }): boolean =>
      this.resolveExpansion(isMenuOpen, previous),
  });

  protected toggleGroupExpanded(): void {
    this.groupExpanded.update((value) => !value);
    if (this.groupExpanded()) {
      this.projectExpanded.set(false);
    }
  }

  protected toggleProjectExpanded(): void {
    this.projectExpanded.update((value) => !value);
    if (this.projectExpanded()) {
      this.groupExpanded.set(false);
    }
  }

  protected onGroupSelected(group: Group): void {
    this.groupSelected.emit(group);
  }

  protected onProjectSelected(project: Project): void {
    this.projectSelected.emit(project);
  }

  protected onLogout(): void {
    this.logoutRequested.emit();
  }

  private resolveExpansion(isMenuOpen: boolean, previous?: { value: boolean }): boolean {
    return isMenuOpen ? (previous?.value ?? false) : false;
  }
}
